'use strict';

$(document).ready(function () {
    require('./contentSearch/contentSearch').init();
});

